import React, { useEffect, useState } from 'react'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import PaymentForm from './PayPalPayment'
import { Button, Col, Modal, Radio, Row, Table } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {
  useParams,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'

const PayPalPayment = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [policydetail, setPolicyDetail] = useState([]);
  const [paymentDetail, setPaymentDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { policyId } = useParams();
  const history = useHistory();
  const [selectedPaymentType, setSelectedPaymentType] = useState('Cash');
  const UserRole = JSON.parse(localStorage.getItem("user"))?.role;
  const columns = [
    {
      key: 'policy_cover',
      title: 'Policy Cover ',
      dataIndex: 'policy_cover',
    },
    {
      key: 'riskitem',
      title: 'Risk Item ',
      dataIndex: 'riskitemname',
    },
    {
      key: 'address',
      title: 'Risk Address',
      dataIndex: 'address',
    },
    {
      key: 'suminsured',
      title: 'Sum Insured',
      dataIndex: 'suminsured',
      render: suminsured => {
        return parseFloat(suminsured).toFixed(2)
      },
    },
    {
      key: 'Proratapremium',
      title: 'Premium',
      dataIndex: 'annualpremium',
      render: annualpremium => {
        return parseFloat(annualpremium).toFixed(2)
      },
    },
  ]
  useEffect(() => {
    if (policyId) {
      fetchPolicyDetail(policyId)
    }
  }, [policyId])

  const submitroute = () => {
    history.push('/policies')
  }

  const fetchPolicyDetail = async policyId => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/Policy/GetPolicybyid/${policyId}`,
        'GET',
      )
      setPolicyDetail(response.data || [])
      setData(response.data?.policydetail.riskitemdetails)
      setPaymentDetail(response.data?.payment_detail || [])
      console.log('==>>', response.data)
    } catch (error) {
      console.error('Error fetching assigned users', error)
    } finally {
      setLoading(false)
    }
  }
  const HandlePayNow = async () => {
    if (UserRole == "311") {
      setLoading(true)
      if (selectedPaymentType == "Cash") {
        const payload = {
          policyNumber: policydetail?.policydetail?.policynumber,
          amountToPay: policydetail?.payment_detail?.premium,
          PaymentMode: selectedPaymentType
        }
        try {
          const res = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/SendCashPaymentEmails/send-cash-payment-emails`, 'POST', payload)
          if (res.success) {
            toast.success('Please check your email and contact your broker to complete the cash payment.')
            // if (onSuccess) onSuccess()
            setLoading(false)
            history.push('/policies')
          } else {
            setLoading(false)
            toast.error(res.message || 'Something went wrong')
          }
        } catch (err) {
          setLoading(false)
          toast.error('Request failed')
        }
      } else if (selectedPaymentType == "BankTransfer") {
        const payload = {
          policyNumber: policydetail?.policydetail?.policynumber,
          amountToPay: policydetail?.payment_detail?.payment_amount,
          PaymentMode: selectedPaymentType
        }
        try {
          const res = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/SendCashPaymentEmails/send-cash-payment-emails`, 'POST', payload)
          if (res.success) {
            toast.success('Please check your email and contact your broker to complete the bank payment.')
            // if (onSuccess) onSuccess()
            setLoading(false)
            history.push('/policies')
          } else {
            setLoading(false)
            toast.error(res.message || 'Something went wrong')
          }
        } catch (err) {
          setLoading(false)
          toast.error('Request failed')
        }
      } else {
        setModalVisible(true)
      }
    }
    else if (UserRole == "305" && selectedPaymentType == "Cash") {
      setModalVisible(true)
    }
    else {
      setModalVisible(true)
    }
  }
  return (
    <>
      {/* <Layouts title="Email Templates" classname="dashboard"> */}
      <div className="body-height">
        <div className="bg-white">
          <div className="dash-bg-white">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#0C1362',
                      fontWeight: '600',
                      fontSize: '25px',
                    }}>
                    Payment
                  </h3>
                </div>
              </Col>
              <div className="btn-group-success">
                <Button
                  className="btn-success"
                  size="default"
                  value={'submit'}
                  onClick={submitroute}>
                  Go Back
                </Button>
              </div>
            </Row>
          </div>
          <div className="dash-bg-white">
            <div className="container-box" style={{ marginTop: '15px' }}>
              <div
                id="divToPrint"
                className="white-box-bg"
                style={{ padding: '30px 15px 50px' }}>
                <div>
                  <h4
                    style={{
                      padding: '5px 2px',
                      fontSize: '14px',
                      fontWeight: '800',
                      margin: '0',
                      textTransform: 'capitalize',
                    }}>
                    Customer Details
                  </h4>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '5px 20px 20px 0',
                          fontSize: '14px',
                          color: '#000',
                          fontWeight: '500',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>Name : </li>
                        <li>Mobile:</li>
                        <li>Address:</li>
                        <li>Age:</li>
                        <li>National Id:</li>
                      </ul>
                    </div>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '5px 20px 20px 0',
                          fontSize: '14px',
                          color: '#000',
                          fontWeight: '500',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>
                          {' '}
                          {policydetail?.customerdetail?.clientfirstname ||
                            '-'}{' '}
                          {policydetail?.customerdetail?.clientsurname}
                        </li>
                        <li>
                          {policydetail?.customerdetail?.clientcontactnumber ||
                            '-'}
                        </li>
                        <li>
                          {policydetail?.customerdetail?.clientaddress1 || '-'}
                        </li>
                        <li>
                          {policydetail?.customerdetail?.clientage || '-'}
                        </li>
                        <li>
                          {policydetail?.customerdetail?.nationalid || '-'}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <h4
                  style={{
                    padding: '5px 2px',
                    fontSize: '14px',
                    fontWeight: '800',
                    margin: '0',
                    textTransform: 'capitalize',
                  }}>
                  Policy Details
                </h4>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Policy Number : </li>
                      <li>Period of Insurance:</li>
                      <li>Transaction Date:</li>
                      <li>Currency:</li>
                      <li>Annual Premium(including stamp duty):</li>
                      <li>Term Premium(including stamp duty):</li>
                    </ul>
                  </div>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{policydetail?.policydetail?.policynumber || '-'}</li>
                      <li>
                        {policydetail?.policydetail?.policystartdate || '-'}
                        <b> To </b>
                        {policydetail?.policydetail?.policyexpirytdate || '-'}
                      </li>
                      <li>{policydetail?.policydetail?.transactionDate || '-'}</li>
                      <li>{policydetail?.policydetail?.currency || '-'}</li>
                      <li>
                        {policydetail?.policydetail?.grandtotalannualpremium || '-'}
                      </li>
                      <li>
                        {policydetail?.policydetail?.grandtotaltermpremium || '-'}
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h4
                    style={{
                      padding: '5px 2px',
                      fontSize: '14px',
                      fontWeight: '800',
                      margin: '0',
                      textTransform: 'capitalize',
                    }}>
                    Product Details
                  </h4>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '0 20px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '700',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>Product :</li>
                      </ul>
                    </div>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '0 20px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '700',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>{policydetail?.policydetail?.productname}</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <h4
                      style={{
                        padding: '5px 2px',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '800',
                        margin: '0',
                        textTransform: 'capitalize',
                      }}>
                      Policy Cover Details
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>Policy Cover:</li>
                        </ul>
                      </div>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>{policydetail?.policydetail?.policyriskcover}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="dataSource-grid">
                    <Table
                      rowKey={record => record.policyriskitemid}
                      columns={columns}
                      dataSource={data}
                      pagination={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  color: '#000',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Select Payment Type
              </h4>

              <Radio.Group
                onChange={e => setSelectedPaymentType(e.target.value)}
                value={selectedPaymentType}>
                <Radio value="Cash">Cash</Radio>
                <Radio value="PayPal">PayPal</Radio>
                <Radio value="BankTransfer">Bank Transaction</Radio>
              </Radio.Group>
            </div>

            <Button
              className="btn-success"
              onClick={() => HandlePayNow()}>
              Pay Now
            </Button>

            {paymentDetail.payment_type === 'Card' && paymentDetail.payment_status == 'Paid' && (
              <Button
                type="primary"
                style={{ marginTop: '10px' }}
                onClick={() => {
                  toast.info('Subscription to automatic deduction initiated.');
                  window.location.href = `/subscribe/${policyId}`;
                }}
              >
                Subscribe for Automatic Deduction
              </Button>
            )}

            <Modal
              title={'Payment'}
              centered
              visible={modalVisible}
              footer={null}
              onCancel={() => setModalVisible(false)}
              width={760}>
              <PayPalScriptProvider
                options={{
                  clientId: process.env.REACT_APP_BASE_URL_PAY_PAL,
                  // clientId: '',
                  currency: 'USD',
                }}>
                <PaymentForm
                  customerdetail={policydetail?.customerdetail}
                  policydetail={policydetail?.policydetail}
                  payment_detail={policydetail?.payment_detail}
                  type={selectedPaymentType}
                />
              </PayPalScriptProvider>
            </Modal>
          </div>
          {/* </Layouts> */}
        </div>
      </div>
    </>
  )
}

export default PayPalPayment
